<template>
    <div class="block-editor timeout">
        <a-alert
            message="Dikkat Edilmesi Gereken!"
            description="Varsayılan Zaman Aşımı, Normal Zaman Aşımı bloğundan küçük olamaz ve Zaman Aşımı blokları ayarlardaki 'Pasif Chat Süresi' ve 'Pasif Chat Kapatma Süresi' toplamından küçük olamaz. Bu kurallar çervesine uyulmaz ise blok çalışmadan sohbet kapanma gibi durumlar olabilir!"
            type="warning"
        />
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Zaman Aşımı (Saniye)</div>
            <a-input-number class="input-number" v-model="clone.timeout" :min="minimunTimeout" />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapState } from "vuex";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";

const log = log2("TimeoutBlock");
export default {
    name: "TimeoutBlock",
    components: { SupsisButton, TiptapEditor },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        global: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            minimunTimeout: 0,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
        }),
    },
    methods: {
        calcMin() {
            if (!this.global) return;
            const inactiveThresholdTime = this.settings.inactiveThresholdTime * 60;
            const inactiveTerminateTime = this.settings.inactiveTerminateTime * 60;
            const total = inactiveThresholdTime + inactiveTerminateTime;
            this.minimunTimeout = Math.min(total * 0.1, 2 * 60);
            if (this.clone.timeout >= total) this.clone.timeout = this.minimunTimeout;
        },
    },
    mounted() {
        this.calcMin();
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.calcMin();
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.timeout {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .timeout-information {
        padding: 10px;
        background: #bdae0d;
        color: black;
    }

    .input-number {
        width: 100%;
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
}
</style>
